import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskGetGtNetLinkService } from "./task-get-gt-net-link.service";
import { TaskQuarterYearEmailSent } from './task-quarter-year-email-sent.service';
import { TaskSyncReserveWithGtNetService } from './task-sync-reserve-with-gtnet.service';
import { TaskGetSentEmailLogsService } from './task-get-sent-email-logs.service';
import { TaskGetGtNetDocumentsService } from './task-get-gtnet-documents.service';
import { TaskReviewTaskFilesService } from './task-review-task-files.service';
import { TaskCancelTaskFilesReviewService } from './task-cancel-task-files-review.service';
import { GetTasksListService } from './get-tasks-list.service';
import {TaskReviseService} from "./task-revise.service";
import { GetTechReportListService } from './get-tech-report-list.service';
import { PatchTaskFileGroupService } from './patch-task-file-group.service';
import { TaskPartnerCommentSyncService } from './task-partner-comment-sync.service';
import { UpdateTaskService } from './update-task.service';
import { GetTaskAuditDataService } from './get-task-audit-data.service';
import { GetTaskAuditDataDetailService } from './get-task-audit-data-detail.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    UpdateTaskService,
    TaskCancelTaskFilesReviewService,
    TaskReviewTaskFilesService,
    TaskGetGtNetDocumentsService,
    TaskSyncReserveWithGtNetService,
    TaskGetGtNetLinkService,
    TaskQuarterYearEmailSent,
    TaskGetSentEmailLogsService,
    GetTasksListService,
    TaskReviseService,
    GetTechReportListService,
    PatchTaskFileGroupService,
    TaskPartnerCommentSyncService,
    GetTaskAuditDataService,
    GetTaskAuditDataDetailService,
  ],
})
export class TasksModule {}
